export const hireReactPara = [
"MitrahSoft team will help you hire the best ReactJS developers for your application development. We have technical experts who can help you along with updated tools and resources to offer excellent ReactJS solutions. Hire the best ReactJS resource from MitrahSoft and enjoy the benefits of experience at a budget-friendly cost.",
"Looking to hire skilled React developer to build your React web application? Or would you like to hire a team of React developers? Get in touch for a free quote!",
"Outsource & Save Upto 60% Cost & Time, No Hiring Fee. We provide,",
]
export  const hireReactParaList = [
"Complete Control Over Team",
"Agile & Adaptive Development",
"Non-Disclosure Agreement",
"Secure & Risk-Free Development",
"Zero Headache React Developers",
"Best React Development Practices",
]
export const commonCardData = [
{
    h2: "Tech consultation",
    p: "We provide insights and direction on how to hire the best-fit resources and set milestones to address the requirements at hand.",
    h1: "Step 01.",
}, {
    h2: "Hire right, hire fast",
    p: "Our well trained resources could get started on your project as quickly as they can mostly within 48 hours of contract signing them up.",
    h1: "Step 02.",
}, {
    h2: "Scale up at short notice",
    p: "We can onboard more people to your team in the middle of a project at short notice, if the project need arises.",
    h1: "Step 03.",
}, {
    h2: "Excellent Training",
    p: "Our training program not just enables our ReactJS Developers to strengthen their ability to program well, but also skill themselves in other essential aspects of workplace competence, such as communication, collaboration and leadership.",
    h1: "Step 04.",
}, {
    h2: "Full-stack expertise",
    p: "We have skilled developers and experts who can hold expertise that spans various domains and technologies.",
    h1: "Step 06.",
}, {
    h2: "QA & testing",
    p: "Hire our dedicated testers who will make sure that all the bugs are fixed and your app is bug free for smooth launch.",
    h1: "Step 06.",
}, 
]
export const productDevImages = [
    "service1",
    "service2"
]
export const productDevContent = [
{
    title: "Top Front-end/Backend Developers",
}, {
    title: "Advanced ReactJS Trends",
}, {
    title: "Dynamic Skills",
}, {
    title: "Flexible Hiring Models",
}, {
    title: "Dedicated Resources",
}, {
    title: "One-to-one Communication",
}, {
    title: "Transparency",
}, {
    title: "Cost-effective",
}, {
    title: "Consistent Delivery",
}, {
    title: "Maintenance & Support",
}, 
]
export const Contact = [
"Your search to hire ReactJS Full stack developer / MERN stack developer ends here.",
]